import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import Button from '@prisjakt/ui-button';
import ChevronDown from 'mdi-react/ChevronDownIcon';
import { AppContext } from '@prisjakt/ui-app-context';

const FetchMore = props => {
  const { t } = useContext(AppContext);
  return (
    <div className={props.className}>
      {props.children}
      {props.pageInfo.hasNext && (
        <div>
          <Button
            style={{ width: '100%' }}
            variant="text"
            color="link"
            iconPosition="bottom"
            onClick={props.onFetchMoreData}
            icon={<ChevronDown />}
          >
            {t('common', 'button.show-more')}
          </Button>
        </div>
      )}
    </div>
  );
};

const { shape, node, number, func, bool, string } = PropTypes;

FetchMore.propTypes = {
  children: node.isRequired,
  pageInfo: shape({
    limit: number,
    offset: number,
    hasNext: bool,
  }).isRequired,
  onFetchMoreData: func,
  className: string,
};

FetchMore.defaultProps = {
  onFetchMoreData: () => {},
  className: undefined,
};

export default memo(FetchMore);
